/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurement } from './APIMeasurement';
import {
    APIMeasurementFromJSON,
    APIMeasurementFromJSONTyped,
    APIMeasurementToJSON,
} from './APIMeasurement';

/**
 * A simplified version of the ArticleSerializer that is tailored to provide
 * all information that are important for a GuestRequest part.
 * 
 * Note:
 *     This serializer is meant to be used as a read-only serializer. To deserialize
 *     an incoming Part POST-request, use the PartCreationSerializer.
 * @export
 * @interface APIPart
 */
export interface APIPart {
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    hoopsPartId?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIPart
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPart
     */
    readonly weight: APIMeasurement;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPart
     */
    readonly length: APIMeasurement;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPart
     */
    readonly width: APIMeasurement;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPart
     */
    readonly height: APIMeasurement;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPart
     */
    readonly volume: APIMeasurement;
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    qualityClass?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    readonly material: string;
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    readonly properties: string;
    /**
     * 
     * @type {string}
     * @memberof APIPart
     */
    readonly files: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIPart
     */
    readonly requests: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof APIPart
     */
    isBomBase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIPart
     */
    readonly hasChildren: boolean;
}

/**
 * Check if a given object implements the APIPart interface.
 */
export function instanceOfAPIPart(value: object): value is APIPart {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('volume' in value) || value['volume'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    if (!('properties' in value) || value['properties'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('hasChildren' in value) || value['hasChildren'] === undefined) return false;
    return true;
}

export function APIPartFromJSON(json: any): APIPart {
    return APIPartFromJSONTyped(json, false);
}

export function APIPartFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPart {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'],
        'hoopsPartId': json['hoops_part_id'] == null ? undefined : json['hoops_part_id'],
        'createdAt': (new Date(json['created_at'])),
        'weight': APIMeasurementFromJSON(json['weight']),
        'length': APIMeasurementFromJSON(json['length']),
        'width': APIMeasurementFromJSON(json['width']),
        'height': APIMeasurementFromJSON(json['height']),
        'volume': APIMeasurementFromJSON(json['volume']),
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'material': json['material'],
        'properties': json['properties'],
        'files': json['files'],
        'requests': json['requests'],
        'isBomBase': json['is_bom_base'] == null ? undefined : json['is_bom_base'],
        'hasChildren': json['has_children'],
    };
}

export function APIPartToJSON(value?: Omit<APIPart, 'self'|'created_at'|'weight'|'length'|'width'|'height'|'volume'|'material'|'properties'|'files'|'requests'|'has_children'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'number': value['number'],
        'hoops_part_id': value['hoopsPartId'],
        'quality_class': value['qualityClass'],
        'is_bom_base': value['isBomBase'],
    };
}

